//import React, { useState } from 'react';
import '../../styles/Styles.css';

const WaitingComponent = () => {

    const handleRefresh = () => {
        window.location.reload();
      };

    return (
        <div className="error-container recaptcha-container">
            <div className="error-message recaptcha-error" id="waiting">Wait while your request is being verified...</div>
            <button onClick={handleRefresh} className="form-button" id="refreshBtn">Refresh</button>
        </div>
    )
    
};

export default WaitingComponent;